import { CalendarClock } from "lucide-react";
import { IMAGES } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";
import { GhostButton } from "../components/shared/Buttons";

const COLUMNS = ["Day", "Time", "Arena", "Discipline", "Division", "Competition Stage"];

export default function Schedule() {
  return (
    <>
      <PageHero
        eyebrow="Schedule"
        title="The Timetable"
        intro="When the official schedule is confirmed, this page will present the full competition timetable — by day, arena, discipline and division."
        image={IMAGES.hero}
        testId="schedule-page-hero"
      />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <Reveal>
          <div className="overflow-hidden border border-white/5">
            <div className="hidden grid-cols-6 gap-px bg-white/5 md:grid">
              {COLUMNS.map((c) => (
                <div key={c} className="bg-ink-raised px-5 py-4 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-slate-400">
                  {c}
                </div>
              ))}
            </div>
            <div data-testid="schedule-coming-soon" className="grid place-items-center bg-ink-soft px-6 py-28 text-center sm:py-36">
              <div>
                <CalendarClock className="mx-auto h-10 w-10 text-kred" />
                <h2 className="mt-8 font-display text-5xl uppercase tracking-wide text-bone sm:text-6xl">
                  Official Schedule <span className="text-gold">Coming Soon</span>
                </h2>
                <p className="mx-auto mt-6 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">
                  The competition timetable will be published once event dates and participating
                  organisations are confirmed. Follow the news page for the announcement.
                </p>
                <div className="mt-10 flex flex-wrap justify-center gap-4">
                  <GhostButton to="/news" testId="schedule-news-button">
                    Follow Announcements
                  </GhostButton>
                  <GhostButton to="/disciplines" testId="schedule-disciplines-button">
                    View Martial Arts
                  </GhostButton>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
